import AddIcon from "@mui/icons-material/Add";
import type {UseEntityData} from "crqlar-react-common/dist/components/useEntity";
import type {ApaleoConfig} from "crqlar-react-common/dist/models/integrations/apaleo/apaleo.config";
import {ApaleoTaskService} from "crqlar-react-common/dist/services/integrations/apaleo/apaleoTask.service";
import {useTranslation} from "react-i18next";
import SyncTasksTable from "../../common/SyncTasksTable";

interface Props {
    configData: UseEntityData<ApaleoConfig>
}

const ApaleoTasks = ({configData}: Props) => {
    const {t} = useTranslation();
    const configId = configData.item.id;

    return (
        <SyncTasksTable
            configId={configId}
            tableId="system-apaleo-sync-tasks"
            list={ApaleoTaskService.getAll}
            actions={[{
                id: 'btn-schedule-full-sync',
                label: t('Schedule full sync'),
                startIcon: <AddIcon/>,
                onClick: () => ApaleoTaskService.scheduleFullSync(configId!)
            }]}
        />
    );
};

export default ApaleoTasks;
